import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatIndianNumber } from "../utiles/FormatIndianNumber";
import TableLayout from "./TableLayout";
import useLocale from "../locales";

const EducationTable = ({showTable , historyData = null,
  shouldGenerateReport,
  setShouldGenerateReport,calcDone}) => {
  const { textData } = useLocale();
    const [reportData , setReportData] = useState([]);
    const { loanAmmount , timePeriod , intrestRate , emi} = useSelector((state) => state. educationCalculator);
 
    useEffect(() => {
        if(historyData){
            generateHistoryReport();
        }
       

    }, [showTable, loanAmmount , timePeriod , intrestRate , emi]);
    
  useEffect(() => {
    if (shouldGenerateReport) {
      generateReportData();
      setShouldGenerateReport(false);
    }else if (!calcDone) {
    setReportData([]); 
  }
  generateHistoryReport();
}, [shouldGenerateReport, calcDone, historyData]);

const generateHistoryReport=()=>{
  if (!Array.isArray(historyData) || historyData.length === 0) {
    return;
  }

  const educationData = historyData[0];
  const principal = parseFloat(educationData.totalInvestment);
  const rate = parseFloat(educationData.intrestRate);
  const monthlyRate = rate ;
  const numMonths = parseFloat(educationData.tenure) * 12;
  const monthlyPayment = (educationData.emi);
  
  let yearlyData = [];
  let remainingBalance = principal;
  let totalInterestPaid = 0;
  let totalPrincipalPaid = 0;
  let totalInterestRatePaid = 0;
  
  for (let year = 1; year <= timePeriod; year++) {
    const startingBalance = remainingBalance;
    let yearlyInterestPaid = 0;
    let yearlyPrincipalPaid = 0;
    
    for (let month = 1; month <= 12; month++) {
      if (remainingBalance <= 0) break;
      
      const interestForMonth = remainingBalance * monthlyRate;
      
      const principalForMonth = Math.min(monthlyPayment - interestForMonth, remainingBalance);
      
      yearlyInterestPaid += interestForMonth;
      yearlyPrincipalPaid += principalForMonth;
      remainingBalance -= principalForMonth;
      
      if (remainingBalance <= 0) {
        remainingBalance = 0;
        break;
      }
    }
    
    totalInterestRatePaid = yearlyInterestPaid;
    totalInterestPaid += yearlyInterestPaid;
    totalPrincipalPaid = yearlyPrincipalPaid;
    
    yearlyData.push({
      year: year,
      openingBalance: startingBalance,
      intrestPaid: yearlyInterestPaid,
      principlePaid: yearlyPrincipalPaid,
      monthlyPayment: monthlyPayment,
      totalRepayment: totalPrincipalPaid + totalInterestRatePaid,
      closingBalance: remainingBalance,
      totalInterestPaid:totalInterestPaid
    });
    
    if (remainingBalance <= 0) {
      break;
    }
  }
  
  setReportData(yearlyData);

}

    const generateReportData = () => {
        const principal = parseFloat(loanAmmount);
        const rate = parseFloat(intrestRate) / 100;
        const monthlyRate = rate / 12;
        const numMonths = parseFloat(timePeriod) * 12;
        const monthlyPayment = emi;
        
        let yearlyData = [];
        let remainingBalance = principal;
        let totalInterestPaid = 0;
        let totalPrincipalPaid = 0;
        let totalInterestRatePaid = 0;
        
        for (let year = 1; year <= timePeriod; year++) {
          const startingBalance = remainingBalance;
          let yearlyInterestPaid = 0;
          let yearlyPrincipalPaid = 0;
          
          for (let month = 1; month <= 12; month++) {
            if (remainingBalance <= 0) break;
            
            const interestForMonth = remainingBalance * monthlyRate;
            
            const principalForMonth = Math.min(monthlyPayment - interestForMonth, remainingBalance);
            
            yearlyInterestPaid += interestForMonth;
            yearlyPrincipalPaid += principalForMonth;
            remainingBalance -= principalForMonth;
            
            if (remainingBalance <= 0) {
              remainingBalance = 0;
              break;
            }
          }
          
          totalInterestRatePaid = yearlyInterestPaid;
          totalInterestPaid += yearlyInterestPaid;
          totalPrincipalPaid = yearlyPrincipalPaid;
          
          yearlyData.push({
            year: year,
            openingBalance: startingBalance,
            intrestPaid: yearlyInterestPaid,
            principlePaid: yearlyPrincipalPaid,
            monthlyPayment: monthlyPayment,
            totalRepayment: totalPrincipalPaid + totalInterestRatePaid,
            closingBalance: remainingBalance,
            totalInterestPaid:totalInterestPaid
          });
          
          if (remainingBalance <= 0) {
            break;
          }
        }
        
        setReportData(yearlyData);
      };
    const columns =[
        { key: 'year', label: `${textData.tableLabels.year} (${textData.currency})`, format: (value) => value },
{key: 'openingBalance' , label:`${textData.tableLabels.openingBalance} (${textData.currency})` ,format: (value) => `${FormatIndianNumber(Math.round(value))}` },
{key: 'intrestPaid', label: `${textData.tableLabels.intrestPaid} (${textData.currency})`,format: (value) => `${FormatIndianNumber(Math.round(value))}` },
{key: 'principlePaid', label: `${textData.tableLabels.principlePaid} (${textData.currency})`,format: (value) => `${FormatIndianNumber(Math.round(value))}` },
{key: 'monthlyPayment', label: `${textData.tableLabels.monthlyPayment} (${textData.currency})`,format: (value) => `${FormatIndianNumber(Math.round(value))}` },
{key: 'totalRepayment', label: `${textData.tableLabels.totalPay} (${textData.currency})`,format: (value) => `${FormatIndianNumber(Math.round(value))}` },
{key: 'totalInterestPaid', label: `${textData.tableLabels.totalInterestPaid} (${textData.currency})`,format: (value) => `${FormatIndianNumber(Math.round(value))}` }
 
];


  return (
 <TableLayout
   showTable={showTable}
   title={`${textData.filterDropDown.educationLoanCalc} ${textData.report}`}
      data={reportData}
   columns={columns}
   analyticsEventName="download_pl_report"
   reportTitle={textData.reportTitle.educationLoan}
   fileName="education_loan_detail"   
   />
  )
}

export default EducationTable



/*
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatIndianNumber } from "../utiles/FormatIndianNumber";
import TableLayout from "./TableLayout";
import useLocale from "../locales";

const EducationTable = ({showTable , historyData}) => {
  const { textData } = useLocale();
    const [reportData , setReportData] = useState([]);
    const { loanAmmount , timePeriod , intrestRate , emi} = useSelector((state) => state. educationCalculator);
 
    useEffect(() => {
        if(historyData){
            generateHistoryReport();
        }
        else if( showTable &&loanAmmount && timePeriod && intrestRate && emi)
        {
            generateReportData();
        }

    }, [showTable, loanAmmount , timePeriod , intrestRate , emi]);

const generateHistoryReport=()=>{
  if (!Array.isArray(historyData) || historyData.length === 0) {
    return;
  }

  const educationData = historyData[0];
  
  // Parse necessary values from the saved history data
  const principal = parseFloat(educationData.totalInvestment);
  const rate = parseFloat(educationData.intrestRate) / 100;  // Convert percentage to decimal
  const monthlyRate = rate / 12;
  const numMonths = parseFloat(educationData.tenture) * 12;
  const month = parseFloat(educationData.tenture);
  const monthlyPayment = parseFloat(educationData.emi); 
  
  let yearlyData = [];
  let remainingBalance = principal;
  let totalInterestPaid = 0;
  let totalPrincipalPaid = 0;
  let totalInterestRatePaid = 0;
  
  for (let year = 1; year <= numMonths; year++) {
    const startingBalance = remainingBalance;
    let yearlyInterestPaid = 0;
    let yearlyPrincipalPaid = 0;
    
    for (let month = 1; month <= 12; month++) {
      if (remainingBalance <= 0) break;
      
      const interestForMonth = remainingBalance * monthlyRate;
      
      const principalForMonth = Math.min(monthlyPayment - interestForMonth, remainingBalance);
      
      yearlyInterestPaid += interestForMonth;
      yearlyPrincipalPaid += principalForMonth;
      remainingBalance -= principalForMonth;
      
      if (remainingBalance <= 0) {
        remainingBalance = 0;
        break;
      }
    }
    
    totalInterestRatePaid = yearlyInterestPaid;
    totalInterestPaid += yearlyInterestPaid;
    totalPrincipalPaid = yearlyPrincipalPaid;
    
    yearlyData.push({
      year: year,
      openingBalance: startingBalance,
      intrestPaid: yearlyInterestPaid,
      principlePaid: yearlyPrincipalPaid,
      monthlyPayment: monthlyPayment,
      totalRepayment: totalPrincipalPaid + totalInterestRatePaid,
      closingBalance: remainingBalance,
      totalInterestPaid:totalInterestPaid
    });
    
    if (remainingBalance <= 0) {
      break;
    }
  }
  
  setReportData(yearlyData);

}

    const generateReportData = () => {
        const principal = parseFloat(loanAmmount);
        const rate = parseFloat(intrestRate) / 100;
        const monthlyRate = rate / 12;
        const numMonths = parseFloat(timePeriod) * 12;
        const monthlyPayment = emi;
        
        let yearlyData = [];
        let remainingBalance = principal;
        let totalInterestPaid = 0;
        let totalPrincipalPaid = 0;
        let totalInterestRatePaid = 0;
        
        for (let year = 1; year <= timePeriod; year++) {
          const startingBalance = remainingBalance;
          let yearlyInterestPaid = 0;
          let yearlyPrincipalPaid = 0;
          
          for (let month = 1; month <= 12; month++) {
            if (remainingBalance <= 0) break;
            
            const interestForMonth = remainingBalance * monthlyRate;
            
            const principalForMonth = Math.min(monthlyPayment - interestForMonth, remainingBalance);
            
            yearlyInterestPaid += interestForMonth;
            yearlyPrincipalPaid += principalForMonth;
            remainingBalance -= principalForMonth;
            
            if (remainingBalance <= 0) {
              remainingBalance = 0;
              break;
            }
          }
          
          totalInterestRatePaid = yearlyInterestPaid;
          totalInterestPaid += yearlyInterestPaid;
          totalPrincipalPaid = yearlyPrincipalPaid;
          
          yearlyData.push({
            year: year,
            openingBalance: startingBalance,
            intrestPaid: yearlyInterestPaid,
            principlePaid: yearlyPrincipalPaid,
            monthlyPayment: monthlyPayment,
            totalRepayment: totalPrincipalPaid + totalInterestRatePaid,
            closingBalance: remainingBalance,
            totalInterestPaid:totalInterestPaid
          });
          
          if (remainingBalance <= 0) {
            break;
          }
        }
        
        setReportData(yearlyData);
      };
    const columns =[
        { key: 'year', label: textData.tableLabels.year, format: (value) => value },
{key: 'openingBalance' , label:textData.tableLabels.openingBalance ,format: (value) => `${textData.currency}${FormatIndianNumber(Math.round(value))}` },
{key: 'intrestPaid', label: textData.tableLabels.intrestPaid,format: (value) => `${textData.currency}${FormatIndianNumber(Math.round(value))}` },
{key: 'principlePaid', label: textData.tableLabels.principlePaid,format: (value) => `${textData.currency}${FormatIndianNumber(Math.round(value))}` },
{key: 'monthlyPayment', label: textData.tableLabels.monthlyPayment,format: (value) => `${textData.currency}${FormatIndianNumber(Math.round(value))}` },
{key: 'totalRepayment', label: textData.tableLabels.totalPay,format: (value) => `${textData.currency}${FormatIndianNumber(Math.round(value))}` },
{key: 'totalInterestPaid', label: textData.tableLabels.totalInterestPaid,format: (value) => `${textData.currency}${FormatIndianNumber(Math.round(value))}` }
 
];


  return (
 <TableLayout
   showTable={showTable}
   title={`${textData.filterDropDown.educationLoanCalc} ${textData.report}`}
   data={reportData}
   columns={columns}
   analyticsEventName="download_pl_report"
   reportTitle="Education_loan Calculation"
   fileName="education_loan_detail"   
   />
  )
}

export default EducationTable
*/